// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4u-1";
export var standaloneTable = "_4u-0";